import { render, staticRenderFns } from "./getinfoMessage.vue?vue&type=template&id=9b15af9a&scoped=true"
import script from "./getinfoMessage.vue?vue&type=script&lang=js"
export * from "./getinfoMessage.vue?vue&type=script&lang=js"
import style0 from "./getinfoMessage.vue?vue&type=style&index=0&id=9b15af9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b15af9a",
  null
  
)

export default component.exports